import React, { Fragment } from "react";

import Header from "../../components/header/header";

import "./account.scss";

const AccountDeletion = () => (
  <Fragment>
    <Header />
    <section className="page_container">
      <div className="content_section">
        <h2 className="content_heading">
          Account Deletion
        </h2>
        <p>
          If you wish to delete your account and associated data from our <strong>PiRentz Partner</strong> or <strong>PiRentz Hiring</strong> or <strong>PiRentz Operator</strong> apps, we have streamlined a simple process for your convenience. Please follow the steps outlined below:
        </p>
        <p>
          Step 1: Write an email to <strong>support@pirentz.com</strong>, expressing your request for account deletion. You can also call us at <strong>18001206969</strong>.
        </p>
        <p>
          Step 2: Within a maximum time frame of 24 hours from the submission of your request, one of our dedicated executives will reach out to you for the purpose of <strong>verification and confirmation</strong>.
        </p>
        <p>
          Step 3: Once the confirmation process is completed, your account and all associated data will be permanently deleted. Please note that this deletion will be carried out within <strong>21 working days</strong> from the date of your initial request.
        </p>
        <p>
          We assure you that your request will be handled promptly and with utmost care to ensure the complete removal of your account from our system.
        </p>
      </div>
    </section>
  </Fragment>
);

export default AccountDeletion;